import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { get } from "lodash";

import PlaceholderIMG from "../../../sharedComponents/placeholderImage";
import FlameRating from "../../../sharedComponents/flameRating";
import Tooltip from "../../../sharedComponents/tooltip";
import AddJouralExerciseForm from "../journal/add/addJournalExerciseForm";

const ExerciseCard = ({
	cardInfo,
	history,
	onDelete,
	onClick,
	forceEnable = false,
	logBtn = false,
	dropdown = false,
	addToPlanBtn = false,
	tooltip = null,
	isActive = false
}) => {
	const handleClick = (cardInfo) => {
		onClick && onClick(cardInfo);
	};

	const [journalExercise, setJournalExercise] = useState(null);

	const handleJournalExercise = () => {
		const newExercise = {
			exercise: cardInfo ? cardInfo.id : null,
			type_of_activity: cardInfo ? cardInfo.type : null,
			exercise_name: cardInfo ? cardInfo.name : null,
		};
		setJournalExercise(newExercise);
	};

	return (
		<div key={cardInfo.id} className={`card card-primary ${!forceEnable && cardInfo.already_in_plan ? "inactive" : ""}`}>
			<div className="card-nav">
				{dropdown && (
					<Dropdown>
						<Dropdown.Toggle as="button" className="btn btn-light btn-cell btn-sm" bsPrefix="no-caret">
							<i className="icon icon-more" />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item
								className="btn btn-default"
								as="button"
								onClick={() => history.push(`/fitness/exercises/${cardInfo.id}/edit`)}>
								<i className="icon icon-add-edit" /> Edit
							</Dropdown.Item>
							<Dropdown.Item className="btn btn-default" as="button" onClick={() => onDelete(cardInfo)}>
								<i className="icon icon-trash" /> Delete
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				)}
				{JSON.stringify(addToPlanBtn)}
				{addToPlanBtn && (
					<Tooltip content={tooltip ? tooltip : isActive ? "Remove from journal" : "Add to journal"}>
						<button
							className="btn btn-light btn-cell text-primary-dark btn-sm"
							onClick={() => handleClick(cardInfo)}>
							<i className={`icon icon-${isActive ? "check" : "add-to-plan"}`} />
						</button>
					</Tooltip>
				)}
				{logBtn && (
					<Tooltip content={tooltip ? tooltip : "Journal This"}>
						<button
							className="btn btn-light btn-cell text-primary-dark btn-sm"
							onClick={() => handleJournalExercise()}>
							<i className="icon icon-log-time" />
						</button>
					</Tooltip>
				)}
			</div>
			<div
				className="card-header"
				onClick={() => (!addToPlanBtn && !logBtn ? history.push(`/fitness/exercises/${cardInfo.id}/details`) : false)}>
				<div className="card-image">
					<PlaceholderIMG
						src={get(cardInfo, "main_image.data", "")}
						width="236"
						height="215"
						bg="rgba(0,0,0,0.1)"
						alt={cardInfo.name}
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
					/>
				</div>
				<div className="card-header-data">
					<div className="card-header-tags">
						{/* {!cardInfo.active && <div className="tag tag-warning">Pending</div>} */}
						{cardInfo.featured && <div className="tag tag-primary-dark">Featured</div>}
					</div>
					<div className="card-header-title">{cardInfo.name}</div>
					<div className="d-flex align-items-center">
						<FlameRating className="mr-2" value={cardInfo.flame_value} />
						<div className="small">{cardInfo.flame}</div>
					</div>
				</div>
			</div>

			<div className="card-body pl-3 pr-3">
				{cardInfo && cardInfo.description && cardInfo.description.substr(0, 50)}...
			</div>
			<AddJouralExerciseForm initialValues={journalExercise} onUpdate={() => setJournalExercise(null)} />
		</div>
	);
};

export default ExerciseCard;
